export default {
  home: {
    matchups: {
      today: "Matchups de hoje",
      thisWeek: "Matchups desta semana",
      upcoming: "Próximos matchups",
    },
    actions: {
      showMore: "Mostrar mais",
      showLess: "Mostrar menos",
    },
    empty: {
      parlayMinGames: "Nenhuma tendência disponível ainda. Mínimo de 3 jogos necessário.",
    },
    hundredPercentClub: {
      subtitle: "Props que acertaram em 100% dos jogos",
    },
    advancedTools: {
      subtitles: {
        startingLineups: "Encontre valor quando as escalações iniciais mudarem. Incluído com",
        injuryImpact: "Veja como lesões impactam companheiros de equipe. Incluído com",
        opponentRank: "Explore matchups defensivos favoráveis. Incluído com",
        startingPitchers: "Mire situações contra arremessadores vulneráveis. Incluído com",
        weatherReport: "Use vento e tempo a seu favor. Incluído com",
      },
    },
    predictionMarkets: {
      status: {
        loading: "Carregando mercados...",
        loadError: "Não foi possível carregar os mercados.",
      },
    },
    sidebar: {
      improveExperience: "Melhore sua experiência Linemate",
      getAccess: "TENHA ACESSO A JOGADAS AVANÇADAS E INSIGHTS MAIS PROFUNDOS",
    },
  },
};
